import { useEffect, useState } from 'react'
import { ErroreApi } from '../servizi/api.ts'
import { preparaPasskey, registraPasskey } from '../servizi/accesso-ricordato.ts'
import { useSessione } from '../servizi/sessione.tsx'
import { Avviso } from './Pezzi.tsx'
import { Bottone } from './base.tsx'

type Opzioni = Awaited<ReturnType<typeof preparaPasskey>>

/**
 * «Resta connesso» nella web app dell'iPhone (521): dopo l'accesso con password, Face ID registra una
 * passkey del telefono e per 30 giorni dall'ultimo uso il gestionale si apre senza password. Le opzioni si
 * preparano appena la proposta compare, perche' il tocco porti dritto a Face ID.
 */
export function RestaConnesso() {
  const { aggiorna, chiudiPropostaFaceId } = useSessione()
  const [opzioni, setOpzioni] = useState<{ o: Opzioni; dal: number } | null>(null)
  const [errore, setErrore] = useState<string | null>(null)
  const [inCorso, setInCorso] = useState(false)

  const prepara = () => preparaPasskey()
    .then((o) => setOpzioni({ o, dal: Date.now() }))
    .catch((e) => setErrore(e instanceof ErroreApi ? e.message : 'Non è andata: riprova fra poco.'))
  useEffect(() => { void prepara() }, [])

  async function attiva() {
    if (!opzioni) return
    // Le opzioni valgono cinque minuti: piu' vecchie, se ne preparano altre e serve un secondo tocco.
    if (Date.now() - opzioni.dal > 4 * 60_000) {
      setOpzioni(null); await prepara()
      setErrore('Tocca di nuovo «Attiva Face ID».')
      return
    }
    setErrore(null); setInCorso(true)
    try {
      await registraPasskey(opzioni.o)
      chiudiPropostaFaceId()
      await aggiorna()
    } catch (e) {
      setErrore(e instanceof ErroreApi ? e.message : 'Face ID non attivato: riprova.')
      setOpzioni(null); void prepara()
    } finally {
      setInCorso(false)
    }
  }

  return (
    <div className="resta-connesso" role="dialog" aria-labelledby="resta-connesso-titolo">
      <h2 id="resta-connesso-titolo">Resta connesso su questo telefono</h2>
      <p>
        Per 30 giorni dall’ultimo uso il gestionale si apre con Face ID, senza password. Dopo cinque minuti in
        secondo piano chiede di nuovo Face ID. Lo scolleghi con «Esci» o da «Il mio profilo».
      </p>
      {errore && <Avviso tipo="errore">{errore}</Avviso>}
      <div className="resta-connesso-azioni">
        <Bottone variante="primario" inCorso={inCorso} disabled={!opzioni} onClick={() => { void attiva() }}>
          Attiva Face ID
        </Bottone>
        <Bottone variante="discreto" onClick={chiudiPropostaFaceId}>Non ora</Bottone>
      </div>
    </div>
  )
}
